import { BrowserRouter, Routes, Route } from "react-router-dom"
import { ScrollToTop, Header, Footer } from "./components"
import { Homepage, AboutUs, Gallery, ContactUs, Error } from "./pages"

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Homepage />}></Route>
        <Route path="/about-us" element={<AboutUs />}></Route>
        <Route path="/gallery" element={<Gallery />}></Route>
        <Route path="/contact-us" element={<ContactUs />}></Route>
        <Route path="*" element={<Error />}></Route>
      </Routes>
      <Footer />
    </BrowserRouter>
  )
}

export default App
